import PackageInfo from '../../../../package.json';
import { DynatraceClient } from '@workivate/tho-web-shared';

export const loadDynatraceScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!url) {
      resolve();
      return;
    }
    if (document.querySelector(`script[src="${url}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('crossorigin', 'anonymous');
    script.src = url;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`Failed to load Dynatrace script: ${url}`));
    document.head.insertBefore(script, document.head.firstChild);
  });
};

export const initialiseDynatrace = () => {
  const deploymentEnvironment = import.meta.env.DEPLOYMENT_ENVIRONMENT ?? '';
  DynatraceClient.initDynatrace({
    service: 'usl',
    env: deploymentEnvironment === 'live' ? 'prod' : deploymentEnvironment,
    version: `${PackageInfo.version}_${deploymentEnvironment}`,
  });
};
